import UIkit from 'uikit';
import Swiper, {Pagination} from 'swiper';

Swiper.use([Pagination]);

export default function () {
    let slides = {};
    let reviewsContainer = UIkit.util.$$('.tm-benefits');

    UIkit.util.each(reviewsContainer, (container) => {
        setTimeout(() => {
            let sliderEl = UIkit.util.$('.swiper', container);

            let sliderInstance = new Swiper(sliderEl, {
                slidesPerView: 1.4,
                spaceBetween: 0,
                autoHeight: false,
                centeredSlides: true,
                watchSlidesVisibility: true,
                simulateTouch: false,
                breakpoints: {
                    576: {
                        slidesPerView: 1.2,
                        spaceBetween: 0,
                        autoHeight: false,
                        centeredSlides: true,
                        watchSlidesVisibility: true,
                        simulateTouch: false,
                        allowTouchMove: true,
                    },
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 10,
                        autoHeight: false,
                        allowTouchMove: false,
                        centeredSlides: false,
                    },
                },
                pagination: {
                    el: '.swiper-pagination',
                },
                /*navigation: {
                    nextEl: UIkit.util.$('.swiper-button-next', container),
                    prevEl: UIkit.util.$('.swiper-button-prev', container),
                },*/
                on: {
                    init: function () {
                        slides = this.slides;
                    },
                },
            });
        }, 1000);
    });
}



// WEBPACK FOOTER //
// ./scripts/tourism/benefits.js